export default "__VITE_ASSET__C7AgUIVP__"